import React, { useEffect, useState } from "react";
import { IStudentGradeDetail } from "../../../../../models/student/studentGradeDetail";
import { ROUTER_URL } from "../../../../../constants/routerUrl";
import { setStudentGradeDetail } from "../../../../../store/slices/student/studentGradeSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Chart } from "primereact/chart";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStudentGradeDetail } from "../../../../../action/student/studentGradeDetailsActionCreator";
import { connect } from "react-redux";

const BetaStudentGradeDetails = (props: IStudentGradeDetail) => {
  const { getStudentGrade, studentGrade, userInfo } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getStudentGrade(userInfo?.id);
    }
  }, [userInfo?.id]);

  useEffect(() => {
    return () => {
      dispatch(setStudentGradeDetail([]));
    };
  }, []);

  const handleViewPage = () => {
    navigate(ROUTER_URL.STUDENT_GRADES);
  };

  const [chartData, setChartData] = useState({});

  useEffect(() => {
    if (studentGrade) {
      setChartData({
        labels: studentGrade?.map((student) => student.grade),
        datasets: [
          {
            data: studentGrade?.map((student) => student.percentage),
            backgroundColor: studentGrade?.map((student) => student.colorCode),
            hoverOffset: 4,
          },
        ],
      });
    }
  }, [studentGrade]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "40%",
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return tooltipItem.raw + "%";
          },
        },
      },
      legend: {
        display: false,
        position: "left",
        labels: {
          usePointStyle: true,
          padding: 20,
        },
      },
      datalabels: {
        align: "center",
        color: "white",
        font: {
          weight: "bold",
          size: 14,
        },
        formatter: (value: number) => {
          return `${value}%`;
        },
      },
    },
    elements: {
      arc: {
        borderWidth: 2, // Controls the width of the border between segments
        borderColor: "white", // Adds a white border between segments
        borderRadius: 10, // Rounded edges for the chart segments
      },
    },
  };

  return (
    <>
      <div className="card h-100 student_metrics">
        <a onClick={handleViewPage}>
          <div className="top">
            <div className="img">
              <img src="/assets/images/icon/chart-pie.svg" alt="" />
            </div>
            <div className="desc">
              <h2>Grade Details</h2>
              <span>Grade details for the current term.</span>
            </div>
          </div>
          <div className="dtls gardedistribution">
            <div className="desc">
              <div
                className="legend"
                id="legend-container"
                style={{ width: "100px" }}
              >
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: "rgb(250, 151, 29)" }}
                  ></div>
                  <span>A</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: "rgb(250, 115, 97)" }}
                  ></div>
                  <span>B</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: "rgb(181, 82, 82)" }}
                  ></div>
                  <span>C</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: "rgb(92, 126, 126)" }}
                  ></div>
                  <span>P</span>
                </div>
              </div>
            </div>
            <div className="chartWrap-new">
              <Chart
                type="doughnut"
                data={chartData}
                options={options}
                className=""
                width="200"
                height="200"
                plugins={[ChartDataLabels]}
              />
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getStudentGrade: (studentId: string) => getStudentGradeDetail(studentId),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    studentGrade: state.studentGradeDetail.gradeDetail,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetaStudentGradeDetails);
